module.exports = __webpack_public_path__ + "img/reason4.d6165e0c.png";